import Legend from './Legend.vue';

export * from './components';
export default Legend;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/legend/index.ts